import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { TeamInfoDTO } from '@solverml/api';

/**
 * Componente "Dumb" (Vista) que muestra la información
 * principal del perfil de un equipo.
 */
@Component({
  selector: 'app-team-detail-header',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule
  ],
  templateUrl: './team-detail-header.component.html',
  styleUrls: ['./team-detail-header.component.scss']
})
export class TeamDetailHeaderComponent {
  /**
   * El objeto TeamInfoDTO que se obtuvo de la API.
   */
  @Input({ required: true }) teamInfo!: TeamInfoDTO | null;
}
